<!--
component: SelectPlotIndex
author: Ken Nakamura
description: プロット地図索引図年代選択画面
-->
<template>
  <section class="select-plot-index">
    <div class="head-message">
      {{ headMessage }}
      <v-spacer />
      <v-progress-circular v-show="loading"
        color="primary"
        indeterminate
      ></v-progress-circular>
    </div>
    <!-- ローディング中の進捗バー -->
    <v-progress-linear
      color="deep-purple accent-4"
      rounded
      height="6"
      :active="loading"
      :indeterminate="loading"
      absolute
    ></v-progress-linear>
    <v-container fluid>
      <v-row>
        <v-flex xl2 lg2 md3 sm4 xs6 v-for="(book, index) in indexBooks" :key="index">
          <v-btn @click="jumpPlotIndex(book)" width="95%"
            class="text-h7 my-2 py-7 mx-2"
            :class='[book.oldFlag ?
              "grey darken-1 grey--text text--lighten-1" :
              "green lighten-4 green--text text--darken-4"]'>
            {{book.nendoName}}
          </v-btn>
        </v-flex>
      </v-row>
    </v-container>
    <Dialog error :open="error" :ok="()=>error=false" to="/"
      :title="errorTitle" :body="errorMessage" />
  </section>
</template>

<script>
import Dialog from '../components/Dialog.vue';
import { dbglog } from '../common/utils.js';
import { extractKenkakuPlotIndices, extractKaihatsuPlotIndices } from '../common/apiAccess.js'

export default {
  components: {
    Dialog,
  },
  data: () => {
    return {
      headMessage: '',
      indexBooks: [],
      loading: false,
      error: false,
      errorTitle: 'エラー',
      errorMessage: '',
    }
  },
  props: {
    ward: {
      type: Number,
      default: 0,
    }
  },
  mounted () {
    if (this.unauthorized) {
      this.message = 'ユーザー認証されていません。';
      this.$router.replace('/');
      return;
    }

    this.loading = true;
    if (this.ward > 0) {
      this.wardCode = this.ward;
    }

    if (this.mode == 1) {
      this.message = '建築確認申請プロット地図検索 : ' + this.wardName;
      this.headMessage = '建築確認プロット索引図を検索しています...';
      extractKenkakuPlotIndices(this.wardCode, (data) => {
        this.loading = false;
        if (data.errorCode) {
          if (data.errorCode == 401) {
            this.errorTitle = 'ユーザー認証エラー';
            this.errorMessage = 'ユーザが無効です。ログインし直して下さい。';
            this.error = true;
          }
          else {
            console.log(data.errorCode);
            this.errorTitle = 'エラー';
            this.errorMessage = '建築確認プロット索引図の検索に失敗しました。';
            this.error = true;
          }
        }
        else {
          this.indexBooks = data;
          this.headMessage = '索引図の年代を選択して下さい';
        }
      })
    }
    else if (this.mode == 5 || this.mode == 6) {
      this.message = '開発・造成・土石の堆積プロット地図検索 : ' + this.wardName;
      this.headMessage = '開発・造成・土石の堆積プロット索引図を検索しています...';
      extractKaihatsuPlotIndices(this.wardCode, (data) => {
        this.indexBooks = data;
        this.loading = false;
        this.headMessage = '索引図の年代を選択して下さい';
      })
    }
  },
  computed: {
    token () {
      return this.$store.state.token;
    },
    unauthorized () {
      return this.token == undefined || this.token == null || this.token.length == 0;
    },
    authorized () {
      return !this.unauthorized;
    },
    mode () {
      return this.$store.state.mode;
    },
    wardCode: {
      get() { return this.$store.state.wardCode; },
      set(val) { this.$store.commit('setWardCode', val); }
    },
    wardName () {
      return this.$store.state.wardName;
    },
    message: {
      get() { return this.$store.state.message; },
      set(val) { this.$store.commit('setMessage', val) }
    },
  },
  methods: {
    jumpPlotIndex (book) {
      dbglog(book);
      this.$router.push({ name: 'plot-index', params: { id: book.id } });
    }
  }
}
</script>

<style lang="scss" scoped>

</style>